import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useImperativeHandle, useState } from 'react';
import { View, StyleSheet } from 'react-native';

/**
 * Portal host is the component which actually renders all Portals.
 */
function PortalManager(_, ref) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    portals = _useState2[0],
    setPortals = _useState2[1];
  var mount = function mount(key, children) {
    setPortals([].concat(_toConsumableArray(portals), [{
      key: key,
      children: children
    }]));
  };
  var update = function update(key, children) {
    setPortals(function (portals) {
      return portals.map(function (item) {
        if (item.key === key) {
          return _objectSpread(_objectSpread({}, item), {}, {
            children: children
          });
        }
        return item;
      });
    });
  };
  var unmount = function unmount(key) {
    setPortals(portals.filter(function (item) {
      return item.key !== key;
    }));
  };
  useImperativeHandle(ref, function () {
    return {
      mount: mount,
      update: update,
      unmount: unmount
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, portals.map(function (_ref, i) {
    var key = _ref.key,
      children = _ref.children;
    return /*#__PURE__*/React.createElement(View, {
      key: key,
      collapsable: false
      /* Need collapsable=false here to clip the elevations, otherwise they appear above sibling components */,

      pointerEvents: "box-none",
      style: [StyleSheet.absoluteFill, {
        zIndex: 10 + i
      }]
    }, children);
  }));
}
export default /*#__PURE__*/React.forwardRef(PortalManager);